// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"4ea2c3c8","168":"404ddf12","338":"5e27b64c","544":"4d019490","576":"824e69bd","753":"a3e69dd9","775":"5163ba0e","990":"9fc9c57f"}[chunkId] + ".js";
};